<script>
import ResizeObserver from 'resize-observer-polyfill'
import Tooltip from '@components/tooltip.vue'
import { isMobileMixin } from '@src/mixins/isMobileMixin'

export default {
  components: {
    Tooltip,
  },
  mixins: [isMobileMixin],
  data() {
    return {
      resizeObserver: null,
      currentImageWidth: 0,
      hoveredCircles: [],
    }
  },
  mounted() {
    this.createResizeObserver()
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.loInstructionImageRef)
    }
  },

  methods: {
    createResizeObserver() {
      if (!this.resizeObserver && this.$refs.loInstructionImageRef) {
        this.resizeObserver = new ResizeObserver(this.handleResize)
        this.resizeObserver.observe(this.$refs.loInstructionImageRef)
      }
    },
    handleResize([entry]) {
      this.currentImageWidth = entry.borderBoxSize?.[0].inlineSize
    },
    getDesiredPixelFromBaseImageSize(desiredPixel) {
      const referenceWidth = 1403
      const referencePercentage = (desiredPixel * 100) / referenceWidth
      return this.currentImageWidth * (referencePercentage / 100)
    },
    viewCircleStep(step) {
      if (!this.hoveredCircles.includes(step)) {
        this.hoveredCircles.push(step)
      }
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <div ref="loInstructionImageRef" :class="$style.loInstructionsImageContainer">
      <div>
        <img
          :class="[$style.requiredStepImage]"
          src="@assets/images/Phase2LOStep.png"
          alt="Required User Creation Complete" />
      </div>
    </div>
    <div :class="$style.stepsOverlayContainer">
      <div>
        <span
          id="circle1"
          :class="[$style.stepCircle, !hoveredCircles.includes(1) ? $style.pulsatingCircle : '']"
          :style="{
            'font-size': getDesiredPixelFromBaseImageSize(32) + 'px',
            'line-height': getDesiredPixelFromBaseImageSize(50) + 'px',
            height: getDesiredPixelFromBaseImageSize(50) + 'px',
            width: getDesiredPixelFromBaseImageSize(50) + 'px',
            top: getDesiredPixelFromBaseImageSize(277) + 'px',
            left: getDesiredPixelFromBaseImageSize(545) + 'px',
          }"
          @mouseover="viewCircleStep(1)"
          >1</span
        >
        <Tooltip v-if="!isMobile" icon-hide :placement="'top'" :target="'circle1'" :theme="'green'">
          The Legal Name of your Motto Mortgage office must show next to Authorized to Represent.
        </Tooltip>
        <span
          :class="$style.stepFrame"
          :style="{
            top: getDesiredPixelFromBaseImageSize(302) + 'px',
            left: getDesiredPixelFromBaseImageSize(225) + 'px',
            width: getDesiredPixelFromBaseImageSize(307) + 'px',
            height: getDesiredPixelFromBaseImageSize(54) + 'px',
          }" />

        <span
          id="circle2"
          :class="[$style.stepCircle, !hoveredCircles.includes(2) ? $style.pulsatingCircle : '']"
          :style="{
            'font-size': getDesiredPixelFromBaseImageSize(32) + 'px',
            'line-height': getDesiredPixelFromBaseImageSize(50) + 'px',
            height: getDesiredPixelFromBaseImageSize(50) + 'px',
            width: getDesiredPixelFromBaseImageSize(50) + 'px',
            top: getDesiredPixelFromBaseImageSize(662) + 'px',
            left: getDesiredPixelFromBaseImageSize(758) + 'px',
          }"
          @mouseover="viewCircleStep(2)"
          >2</span
        >
        <Tooltip v-if="!isMobile" icon-hide :placement="'top'" :target="'circle2'" :theme="'green'">
          Authorized to Conduct Business must show "Yes" for the state of operation.
        </Tooltip>
        <span
          :class="$style.stepFrame"
          :style="{
            top: getDesiredPixelFromBaseImageSize(687) + 'px',
            left: getDesiredPixelFromBaseImageSize(653) + 'px',
            width: getDesiredPixelFromBaseImageSize(87) + 'px',
            height: getDesiredPixelFromBaseImageSize(48) + 'px',
          }" />

        <span
          id="circle3"
          :class="[$style.stepCircle, !hoveredCircles.includes(3) ? $style.pulsatingCircle : '']"
          :style="{
            'font-size': getDesiredPixelFromBaseImageSize(32) + 'px',
            'line-height': getDesiredPixelFromBaseImageSize(50) + 'px',
            height: getDesiredPixelFromBaseImageSize(50) + 'px',
            width: getDesiredPixelFromBaseImageSize(50) + 'px',
            top: getDesiredPixelFromBaseImageSize(675) + 'px',
            left: getDesiredPixelFromBaseImageSize(1178) + 'px',
          }"
          @mouseover="viewCircleStep(3)"
          >3</span
        >
        <Tooltip v-if="!isMobile" icon-hide :placement="'top'" :target="'circle3'" :theme="'green'">
          Expand the section by clicking the [+] View Details
        </Tooltip>
        <span
          :class="$style.stepFrame"
          :style="{
            top: getDesiredPixelFromBaseImageSize(687) + 'px',
            left: getDesiredPixelFromBaseImageSize(1248) + 'px',
            width: getDesiredPixelFromBaseImageSize(142) + 'px',
            height: getDesiredPixelFromBaseImageSize(46) + 'px',
          }" />
      </div>
      <div>
        <span
          id="circle4"
          :class="[$style.stepCircle, !hoveredCircles.includes(4) ? $style.pulsatingCircle : '']"
          :style="{
            'font-size': getDesiredPixelFromBaseImageSize(32) + 'px',
            'line-height': getDesiredPixelFromBaseImageSize(50) + 'px',
            height: getDesiredPixelFromBaseImageSize(50) + 'px',
            width: getDesiredPixelFromBaseImageSize(50) + 'px',
            top: getDesiredPixelFromBaseImageSize(755) + 'px',
            left: getDesiredPixelFromBaseImageSize(278) + 'px',
          }"
          @mouseover="viewCircleStep(4)"
          >4</span
        >
        <Tooltip v-if="!isMobile" icon-hide :placement="'top'" :target="'circle4'" :theme="'green'">
          Status must show approved in the expanded section.
        </Tooltip>
        <span
          :class="$style.stepFrame"
          :style="{
            top: getDesiredPixelFromBaseImageSize(780) + 'px',
            left: getDesiredPixelFromBaseImageSize(60) + 'px',
            width: getDesiredPixelFromBaseImageSize(202) + 'px',
            height: getDesiredPixelFromBaseImageSize(46) + 'px',
          }" />
      </div>
      <div>
        <span
          id="circle5"
          :class="[$style.stepCircle, !hoveredCircles.includes(5) ? $style.pulsatingCircle : '']"
          :style="{
            'font-size': getDesiredPixelFromBaseImageSize(32) + 'px',
            'line-height': getDesiredPixelFromBaseImageSize(50) + 'px',
            height: getDesiredPixelFromBaseImageSize(50) + 'px',
            width: getDesiredPixelFromBaseImageSize(50) + 'px',
            top: getDesiredPixelFromBaseImageSize(832) + 'px',
            left: getDesiredPixelFromBaseImageSize(420) + 'px',
          }"
          @mouseover="viewCircleStep(5)"
          >5</span
        >
        <Tooltip v-if="!isMobile" icon-hide :placement="'top'" :target="'circle5'" :theme="'green'">
          Your Motto Mortgage Legal Name, NMLS ID, and Start Date must be listed under Currently Authorized to
          Represent.
        </Tooltip>
        <span
          :class="$style.stepFrame"
          :style="{
            top: getDesiredPixelFromBaseImageSize(866) + 'px',
            left: getDesiredPixelFromBaseImageSize(60) + 'px',
            width: getDesiredPixelFromBaseImageSize(348) + 'px',
            height: getDesiredPixelFromBaseImageSize(83) + 'px',
          }" />
      </div>
    </div>
    <div :class="$style.stepsMobile">
      <div>
        <span :class="$style.stepCircleMobile">1</span>
        <p> The Legal Name of your Motto Mortgage office must show next to Authorized to Represent.</p>
      </div>
      <div>
        <span :class="$style.stepCircleMobile">2</span>
        <p> Authorized to Conduct Business must show "Yes" for the state of operation.</p>
      </div>
      <div>
        <span :class="$style.stepCircleMobile">3</span>
        <p> Expand the section by clicking the [+] View Details</p>
      </div>
      <div>
        <span :class="$style.stepCircleMobile">4</span>
        <p> Status must show approved in the expanded section.</p>
      </div>
      <div>
        <span :class="$style.stepCircleMobile">5</span>
        <p>
          Your Motto Mortgage Legal Name, NMLS ID, and Start Date must be listed under Currently Authorized to
          Represent.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.loInstructionsImageContainer {
  display: flex;
  width: fit-content;
  max-width: 100%;

  > div {
    img {
      max-width: 100%;
    }
  }
}

.requiredStepImage {
  margin-bottom: 10px;
  border-radius: 10px;
}

.stepsOverlayContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.stepCircle {
  position: absolute;
  z-index: 2;
  display: block;
  line-height: 50px;
  color: white;
  text-align: center;
  cursor: help;
  user-select: none;
  background: $secondary-green;
  border-radius: 50%;
}

.stepFrame {
  position: absolute;
  display: block;
  border: 2px solid $secondary-green;
  border-radius: 8px;
}

.pulsatingCircle {
  &::after {
    @media (max-width: $lg-breakpoint) {
      display: none;
    }

    position: relative;
    z-index: -1;
    box-sizing: border-box;
    display: block;
    width: 200%;
    height: 200%;
    margin-top: -150%;
    margin-left: -50%;
    content: '';
    background-color: $secondary-green;
    border-radius: 50%;
    animation: pulse-ring 2s ease-out infinite;
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.33);
  }
  80%,
  100% {
    opacity: 0;
  }
}

@keyframes pulse-dot {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}

.stepsMobile {
  @media (max-width: $lg-breakpoint) {
    display: block;
  }

  display: none;

  > div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 30px;
    }
  }
}

.stepCircleMobile {
  display: block;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  line-height: 30px;
  color: white;
  text-align: center;
  user-select: none;
  background: $secondary-green;
  border-radius: 50%;
}
</style>
